/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-06-11
 */

import React, {Component} from 'react';
import './SubtleMessage.css';
import Button from './Button';

const TIMEOUT_PERIOD_MS = 5000;
const TIMEOUT_CHECK_FREQUENCY_MS = 250;

const COLOURS = [
	'blue',
	'orange',
	'green'
];

class SubtleMessage extends Component {
	constructor() {
		super();
		
		this.state = {
			shown: false
		};
		
		this.hide = () => this.setState({shown: false, timeout: null});
		
		this.checkTimeout = () => {
			const {shown, timeout} = this.state;
			if (!shown || !timeout) return;
			
			if ((timeout - new Date().getTime()) > 0) {
				// Re render to show latest timer and check again soon
				this.forceUpdate();
				setTimeout(this.checkTimeout, TIMEOUT_CHECK_FREQUENCY_MS);
			} else {
				this.hide(); // Time to hide the message
			}
		};
	}
	
	componentDidMount() {
		// Add shown class after rendering to get transition in animation
		setImmediate(() => {
			this.setState({shown: true, timeout: new Date().getTime() + TIMEOUT_PERIOD_MS});
			setTimeout(this.checkTimeout, TIMEOUT_CHECK_FREQUENCY_MS);
		});
	}
	
	render() {
		const {message} = this.props;
		const {shown, timeout} = this.state;
		
		const secondsLeft = Math.round((timeout - new Date().getTime()) / 1000);
		
		return (
			<div className={`SubtleMessage ${shown ? 'shown' : ''} ${COLOURS[secondsLeft % COLOURS.length] || ''}`}>
				<p>{message}</p>
				<div className="SubtleMessage-actions">
					<Button onClick={this.hide} disabled={!shown}>Ok</Button>
					{shown ? (<div className="SubtleMessage-actions-closing">{secondsLeft > 0 ? `Closing in ${secondsLeft} sec` : 'Closing now'}</div>) : undefined}
				</div>
			</div>
		);
	}
}

export default SubtleMessage;


// WEBPACK FOOTER //
// ./src/widgets/SubtleMessage.js